module.exports = __webpack_public_path__ + "img/img-card-3.ca18b79c.png";